export default __webpack_public_path__ + "static/media/pdf.380c55c5.svg";